<template>
  <div class="p-3 md:p-5 border rounded-lg border-dark-b">
    <div class="pb-2 border-b border-dark-b">
      <span class="text-xl font-semibold">Company Overview</span>
    </div>
    <div class="py-4">
      <div class="py-2">
        <span class="font-semibold">Company name: </span>
        <span>{{ supplier.companyOverview.name }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Country/Region: </span>
        <span>{{ supplier.companyOverview.country }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Main Markets: </span>
        <span
          v-for="(market, index) in supplier.mainMarkets"
          :key="`market-${index}`"
        >
          {{ market.region }}
          <span v-if="index !== supplier.mainMarkets.length-1">,: </span>
        </span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Production Capability: </span>
        <span>
          <span>OEM: {{ supplier.productionCapability.oem }}</span>, 
          <span>OBM: {{ supplier.productionCapability.obm }}</span>,
          <span>ODM: {{ supplier.productionCapability.odm }}</span>
        </span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Payment terms: </span>
        <span>{{ supplier.additionalInformation.paymentTerms }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Total Employees: </span>
        <span>{{ supplier.companyOverview.totalEmployees }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Certificates: </span>
        <span
          v-for="(certificate, index) in certificates"
          :key="`certificates-${index}`"
        >
          <a target="_blank" :href="certificate.url" class="text-blue-600">
            {{ certificate.type }}
          </a><span v-if="index !== certificates.length-1">,</span>
        </span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Chinese Company name: </span>
        <span>{{ supplier.companyOverview.chineseName }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Business Type: </span>
        <span
          v-for="(type, index) in supplier.businessTypes"
          :key="`business-type-${index}`"
        >
          {{ type }}
          <span v-if="index !== supplier.mainMarkets.length-1">,</span>
        </span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Total Anual Revenue: </span>
        <span>{{ supplier.companyOverview.totalAnnualRevenue }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">R&D Staff count: </span>
        <span>{{ supplier.companyOverview.rdStaffCount }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">DUNS Number: </span>
        <span>{{ supplier.companyOverview.dunsRegistrationNumber }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Year Established: </span>
        <span>{{ supplier.companyOverview.yearEstablished }}</span>
      </div>
      <div class="py-2">
        <span class="font-semibold">Patents: </span>
        <div v-if="patents.length">
          <span
            v-for="(patent, index) in patents"
            :key="`patent-${index}`"
          >
            <a target="_blank" :href="patent.url" class="text-blue-600">
              Patent {{ index + 1 }}
            </a>
            <span
              v-if="index !== patents.length - 1"
            >,</span>
          </span>
        </div>
        <span v-else>N/A</span>
      </div>
    </div>
    <div class="pb-2 border-b border-dark-b">
      <span class="text-xl font-semibold">Production Capacity</span>
    </div>
    <div class="py-4 overflow-x-auto">
      <table class="md:w-full whitespace-no-wrap">
        <thead class="text-left text-base">
          <th class="h-12">Factory Country / Region</th>
          <th class="h-12 px-6">Factory Size</th>
          <th class="h-12">No. of Production Lines</th>
        </thead>
        <tbody>
          <tr
            v-for="(factory, index) in factories"
            :key="`factory-${index}`"
          >
            <td>{{ factory.location }}</td>
            <td class="px-6">{{ factory.size }}</td>
            <td>{{ factory.totalProductionLines }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SupplierAboutTab',
  props: {
    supplier: {
      type: Object,
      required: true  
    }
  },
  computed: {
    certificates() {
      return this.supplier.additionalInformation.certificates
    },
    patents() {
      return this.supplier.additionalInformation.patents
    },
    factories() {
      return this.supplier.companyOverview.supplierFactory
    }
  }
}
</script>
